import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const links = [
    { label: t("footer.about"), path: "/about" },
    { label: t("footer.privacy"), path: "/privacy" },
    { label: t("footer.security"), path: "/security" },
    { label: t("footer.legal"), path: "/legal" },
    { label: t("footer.terms"), path: "/terms" },
    { label: t("footer.contact"), path: "/contact" },
  ];

  return (
    <footer className="bg-[#fff9f8] py-4 md:py-6 font-sans">
      <div className="container mx-auto px-2 sm:px-4">
        {/* 链接区域 */}
        <nav aria-label="Footer" className="w-full">
          <ul className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 text-gray-800 text-[12px] md:text-sm">
            {links.map((item, idx) => (
              <li key={item.path} className="flex items-center">
                <button
                  onClick={() => navigate(item.path)}
                  className="text-center px-1 py-1 md:px-3 md:py-2 rounded-lg hover:text-sky-700 hover:bg-white/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 transition"
                >
                  {item.label}
                </button>

                {/* 分隔符：仅在 md+ 显示 */}
                {idx < links.length - 1 && (
                  <span className="hidden md:inline-block text-gray-400 px-2 select-none">
                    ｜{/* 全角竖线，与视觉风格一致 */}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </nav>

        {/* 版权信息 */}
        <div className="mt-3 md:mt-4 text-center space-y-0.5 md:space-y-1">
          <div className="text-[11px] md:text-xs text-gray-600 font-semibold">
            {t("footer.medical_institution")}
          </div>
          <div className="text-[8px] sm:text-[9px] md:text-[10px] text-gray-500 leading-tight">
            {t("footer.licensing")}
          </div>
          <div className="text-[10px] md:text-xs text-gray-500 pt-1">
            Copyright © SMHC株式会社 {t("footer.rights")}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
